import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { SharedModule } from '@aiwyn/shared';
import { CxpDeliverableFile } from '../../../../models';
import { CxpDeliverableActionsService } from '../../../../services';
import { DeliverableFileRowComponent } from '../deliverable-file-row/deliverable-file-row.component';

/**
 * Direct injection of `CxpDeliverableActionsService` matches the
 * "thin action service" allowance in the `cxp-architecture` skill — same
 * reasoning as `DeliverableFileRowComponent`. All inputs (`deliverableId`,
 * `files`) arrive via `input()`, the service is stateless w.r.t. module
 * state, and the container has no orchestration to add for these actions.
 */
@Component({
  selector: 'cxp-deliverable-files-list',
  templateUrl: './deliverable-files-list.component.html',
  styleUrls: ['./deliverable-files-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SharedModule, DeliverableFileRowComponent],
})
export class DeliverableFilesListComponent {
  protected readonly actionsService = inject(CxpDeliverableActionsService);

  readonly deliverableId = input.required<number>();
  readonly files = input<CxpDeliverableFile[]>([]);

  onDownloadAllClicked(): void {
    if (this.actionsService.isDownloadingAll() || this.files().length === 0) return;
    this.actionsService.downloadAll(this.deliverableId(), this.files());
  }
}
